import './Badge.css';

export type BadgeColor = 'critical' | 'info' | 'success' | 'warning';

/** Small numeric counter badge, typically overlaid on icons (e.g. notifications). */
export type BadgeProps = {
  /** Numeric count displayed inside the badge. */
  amount?: string;
  /** Semantic color variant. Defaults to `critical`. */
  color?: BadgeColor;
  className?: string;
};

export function Badge({ amount = '21', color = 'critical', className = '' }: BadgeProps) {
  return (
    <span className={['spark-badge', `spark-badge-${color}`, className].filter(Boolean).join(' ')}>
      <span className="spark-badge-amount">{amount}</span>
    </span>
  );
}
